import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from '../components/ButtonComponent'
import { basicDetails, getApiData, postApiCall,getCountry } from '../actions/corporateSignupAction';

const AllCountryAutomatedSignup = (props) => {
    const { steps: stepPageNo, triggerPage: setStepPageNo, triggerErrorMsg: setErrorNotificationmsg } = props.pageDetails;


    useEffect(() => {
        setStepPageNo(4)
     }, []);


     const doRegistration = () => {
        const queryParameters = new URLSearchParams(window.location.search)
        const orgno = queryParameters.get("orgno")
        const countrycode = queryParameters.get("countrycode")
        if(orgno && countrycode) {
        const req = {
            url: `${apiPath()}/corporate/registercompanydetails`,
            headers: {
                'Authorization': 'djsf', 'countrycode':countrycode,
                "content-type": "application/json"
            },
            body: JSON.stringify({
                orgNumber: orgno,
                countryCode: countrycode,
                countryName: countrycode.toUpperCase() === 'SE' ? 'Sweden' : countrycode.toUpperCase() === 'NO' ? 'Norway' : 'Denmark',
            })
        }
        return new Promise((resolve, reject, ) => {
            postApiCall(req)
                .then(data => {
                    if (data) {
                       
                    }

                })
                .catch(error => {
                    logError(error)
                    reject(error)
                })
        })
     }
        
   }
     const logError = error => {
        console.error(error)
    }
    const apiPath = () => {
        return isDevEnvironment() || isTestEnvironment()
            ? "https://api2.test.flysas.com"
            : "https://api2.flysas.com"
    }
    const isDevEnvironment = () => {
        return (
            window.location.hostname === "localhost" ||
            window.location.hostname.match(/\.local/) ||
            window.location.hostname.match(/^10\..+/)
        )
    }
    const isTestEnvironment = () => {
        return !!window.location.hostname.match(/test\./)
    }
    return <>
        <ButtonComponent label="Register" onAction={doRegistration} />

         
    </>

}

const mapStateFromReducer = (state) => ({
    ...state,
    labels: state.corporateSignupReducer.labels || {},
    getSessionStorage: state.corporateSignupReducer.getSessionStorage || {}
})

const mapDispatchToActions = (dispatch) => ({
    basicDetails: (body) => dispatch(basicDetails(body)),
    getApiData: (req) => dispatch(getApiData(req)),
    postApiCall: (req) => dispatch(postApiCall(req))
})
export default connect(
    mapStateFromReducer,
    mapDispatchToActions
)(AllCountryAutomatedSignup);